import React, {useRef} from 'react';
import {ScrollView, useWindowDimensions, View} from 'react-native';
import {Banner, Divider, useTheme} from 'react-native-paper';
import {useAppSelector} from '../../../store/hooks';
import EditorForm from '../editorform';
import {useQuery} from 'react-query';
import EditorVideoComponent from '../video/editorvideo';
import {EditorPlayControls} from '../video/editorplaycontrols';
import {EditorLayer, EditorProject} from '../../../types';
import {getById, getFolderContent, writeItem} from '../../../api';
import Chat from '../../contacts/chat';
import Encoderproject from '../../encoder/encoderproject';

export function DesktopBanner({routeParams, projectId}) {
  const {height, width} = useWindowDimensions();
  const theme = useTheme();
  const hasSelection =
    routeParams.encoder !== undefined ||
    routeParams.chatId !== undefined;
  const mediaData = useQuery(
    ['projectdata', projectId],
    async () => await getById(projectId),
    {
      enabled: projectId ? true : false,
    },
  );
  const mediaRes: EditorProject = mediaData.data;
  const layersQuery = useQuery(
    ['projectLayers', projectId],
    async () => {
      const data = await getFolderContent(projectId);
      const m = await Promise.all(
        data.map(async i => {
          return {
            ...i,
            media: await getFolderContent(i?.id),
          };
        }),
      );
      return m;
    },
  );
  const layers: EditorLayer[] | undefined = layersQuery?.data;
  const video2 = useRef<JSX.IntrinsicElements['video'] | undefined>();
  let dynamicHeight = height / 2;
  const isUploadInProgress = useAppSelector(
    state => state.upload.isUploadInProgress,
  );
  const hasMedia = useAppSelector(
    state => state.media.currentMediaId,
  );
  const isMobile = width < 700;
  const isRendering = useAppSelector(
    state => state.editor.isRendering,
  );
  const isRenderingError = useAppSelector(
    state => state.editor.ffmpegError,
  );
  if (isRendering) dynamicHeight -= 50;
  if (isRenderingError) dynamicHeight -= 200;
  if (isUploadInProgress) dynamicHeight -= 50;
  if (hasMedia) dynamicHeight -= isMobile ? height / 4 : height / 2;
  return (
    <View
      style={{
        margin: 0,
        display: 'flex',
        width: '100%',
        height: dynamicHeight,
        backgroundColor: 'black',
      }}>
      <Divider />
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: dynamicHeight,
        }}>
        <ScrollView
          style={{
            width: '24%',
            height: dynamicHeight,
            display: 'flex',
            marginRight: 5,
          }}
          key={1}
          showsHorizontalScrollIndicator={false}
          showsVerticalScrollIndicator={false}>
          <EditorForm
            projectId={projectId}
            mediaRes={mediaRes}
            video2={video2}
            layers={layers}
            projectQuery={mediaData}
            writeItem={writeItem}
          />
        </ScrollView>
        <View
          style={{
            width: hasSelection ? '45%' : '74%',
            height: dynamicHeight,
            borderLeftWidth: 1,
            borderRightWidth: 1,
            borderLeftColor: 'rgb(73, 69, 79)',
            borderRightColor: 'rgb(73, 69, 79)',
            position: 'relative',
            display: 'flex',
          }}
          key={2}>
          <EditorVideoComponent
            video2={video2}
            projectId={projectId}
            mediaRes={mediaRes}
            layers={layers}
            height={dynamicHeight}
          />
          <EditorPlayControls
            width={'100%'}
            mediaRes={mediaRes}
            layers={layers}
            projectId={projectId}
          />
        </View>
        {hasSelection && (
          <View
            style={{
              width: '30%',
              height: dynamicHeight,
              display: 'flex',
            }}
            key={3}>
            {routeParams?.encoder && (
              <Encoderproject params={routeParams} isEmbed={true} />
            )}
            {routeParams?.chatId && (
              <Chat
                isEmbed={true}
                params={routeParams}
                height={dynamicHeight}
              />
            )}
          </View>
        )}
      </View>
      <Divider />
    </View>
  );
}
